import React from 'react';
import {clsx} from "clsx";

function IconButton({children, onClick, type, disabled, className}) {
	return (
		<button
			onClick={e => {
				e.preventDefault();
				if (disabled) return;
				if (onClick) onClick(e);
			}}
			type={type || 'button'}
			disabled={disabled || false}
			className={clsx(
				"flex items-center justify-center p-2.5 rounded-2xl transition-all duration-300 ease-in-out border-0",
				"bg-white shadow-sm hover:shadow-md hover:bg-gray-50 active:scale-[0.98] text-gray-600 hover:text-[#0b9cbc]",
				disabled && "bg-gray-50 text-gray-300 cursor-not-allowed shadow-none hover:bg-gray-50 hover:text-gray-300 transform-none active:scale-100",
				className
			)}>
			{children}
		</button>
	);
}

export default IconButton;
